<template>
  <section class="command-controls">
    <template v-if="message.kind === 'command' && message.payload.commandKind === 'revise'">
      <ol><li v-for="step in message.payload.steps" :key="step.stepId"><strong>{{ step.title }}</strong><small>{{ step.expectedOutput }}</small></li></ol>
      <template v-if="message.payload.status === 'awaiting_confirmation'">
        <el-button size="small" type="primary" :loading="busy" @click="confirm(true)">确认此变更</el-button>
        <el-button size="small" :disabled="busy" @click="confirm(false)">保留原计划</el-button>
      </template>
      <small v-else>{{ message.payload.status === 'pending_boundary' ? '待当前步骤与必要确认结束后生效' : '此变更提案已处理' }}</small>
    </template>
    <el-button v-for="kind in message.payload.controls || []" :key="kind" size="mini" :loading="busy" @click="control(kind)">{{ labels[kind] }}</el-button>
  </section>
</template>
<script>
import { projectConversation } from '@/apis/project-team'
import { buildProjectCommand } from '@/utils/project-conversation-state.mjs'
export default {
  props: { projectGuid: String, message: Object },
  data: () => ({ busy: false, pending: null, labels: { pause: '当前步骤后暂停', resume: '继续剩余步骤', cancel: '停止本项工作' } }),
  methods: {
    async confirm(approved) { this.busy = true; try {
      await projectConversation('confirmChange', { projectGuid: this.projectGuid, commandGuid: this.message.payload.commandGuid, approved }); this.$emit('changed')
    } catch (e) { this.$message.error(e.message); this.$emit('changed') } finally { this.busy = false } },
    async control(kind) {
      if (this.busy) return
      if (kind === 'cancel') { try { await this.$confirm('停止此项工作并阻止后续派发？已保存成果仍保留，其他工作继续排队。', '确认停止') } catch (_) { return } }
      this.busy = true
      try {
        const context = JSON.stringify([kind, this.message.payload.planVersion, this.message.payload.stateVersion])
        if (!this.pending || this.pending.context !== context) this.pending = { context, id: `pc-command-${Date.now()}-${Math.random().toString(36).slice(2)}` }
        await projectConversation('command', buildProjectCommand(this.projectGuid, this.message.payload, kind, this.pending.id))
        this.pending = null; this.$emit('changed')
      } catch (e) { this.$message.error(e.message); this.$emit('changed') } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.command-controls{margin-top:10px}.command-controls ol{padding:12px 24px;background:#f7f5fc;border-radius:10px}.command-controls li{padding:8px 0}.command-controls small{display:block;color:#9696aa;white-space:pre-wrap;margin-top:6px}
</style>
